import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Measurement ID
// Replace 'G-JKB3JDCR1J' with your actual Measurement ID from Google Analytics
const GA_MEASUREMENT_ID = 'G-JKB3JDCR1J';

/**
 * Hook to track page views in Google Analytics for Single Page Applications.
 * Call this hook once in your App component to automatically track all route changes.
 */
export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Only track if gtag is available and we have a valid measurement ID
    if (typeof window.gtag === 'function' && GA_MEASUREMENT_ID !== 'G-JKB3JDCR1J') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
}

/**
 * Track custom events in Google Analytics
 * @param {string} eventName - The name of the event (e.g., 'conversion', 'button_click')
 * @param {object} eventParams - Additional parameters for the event
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Track a conversion event (useful for tracking when users perform conversions)
 * @param {string} fromUnit - The source unit
 * @param {string} toUnit - The target unit
 * @param {string} category - The conversion category (e.g., 'length', 'temperature')
 */
export function trackConversion(fromUnit, toUnit, category) {
  trackEvent('unit_conversion', {
    from_unit: fromUnit,
    to_unit: toUnit,
    conversion_category: category,
  });
}

export default useGoogleAnalytics;
